import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import { getPublicLocalizedPathname } from 'marketplace-ui-common/utils/urls';
export function getRootUrl() {
  return `/marketplace/${PortalIdParser.get()}`;
}
export function getShortlinkUrl() {
  return '/l/marketplace';
}
export function getPublicRootUrl(lang = 'en') {
  return `${getPublicLocalizedPathname(lang)}/marketplace`;
}
export const getTemplateMarketplaceUrl = (appContext, lang) => {
  const baseUrl = getFullUrl(appContext === 'app' ? 'app' : 'ecosystem', {
    hubletOverride: na1
  });
  if (appContext === 'app') {
    return `${baseUrl}/ecosystem/${PortalIdParser.get()}/marketplace/templates`;
  }
  return `${baseUrl}${getPublicRootUrl(lang)}/templates`;
};
export const getSolutionsDirectoryUrl = (appContext, lang) => {
  const baseUrl = getFullUrl(appContext === 'app' ? 'app' : 'ecosystem', {
    hubletOverride: na1
  });
  if (appContext === 'app') {
    return `${baseUrl}/ecosystem/${PortalIdParser.get()}/marketplace/solutions`;
  }
  return `${baseUrl}${getPublicRootUrl(lang)}/solutions`;
};